// extracted by mini-css-extract-plugin
export var drawerPaper = "_1i-0";
export var itemCard = "_1i-1";
export var itemImage = "_1i-2";